export const computeAvatarUrl = (name: string) => {
  const url = `https://api.dicebear.com/7.x/initials/svg?scale=80&seed=${name?.toLocaleLowerCase()}`
  return url
}
